import cartActiveReducer from './cartActive'
import productsReducer from './products'
import cartReducer from './cart'
import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  cartActive: cartActiveReducer,
  products: productsReducer,
  cart: cartReducer
})

export default rootReducer;